/** The subscription catalog: what the signed-in person's on-demand plans offer. */
export const subscriptionCatalogPath = '/entitlements/subscription-catalog'

/** The API's read of the person's subscription catalog. */
export const subscriptionCatalogApi = '/entitlements/v1/me/subscription-catalog'

/** The courses of the person's subscription catalog, a page at a time. */
export const subscriptionCatalogCoursesApi = `${subscriptionCatalogApi}/courses`

/** Starts a course from the person's subscription catalog. */
export const subscriptionCatalogStartApi = `${subscriptionCatalogApi}/course-assignments`

/** Starts a learning path from the person's on-demand plans (ENT-12). */
export const startLearningPathApi = '/entitlements/v1/me/learning-path-subscriptions'
